import { motion } from 'motion/react'
import { useMemo } from 'react'

const AnkiResultCardStack = ({
	side,
	cards,
	rotateGap,
	startX,
	gapX,
	gapY,
	w = 'w-16',
	h = 'h-20',
}: {
	side: 'left' | 'right'
	cards: number[]
	rotateGap: number
	startX: number
	gapX: number
	gapY: number
	w?: string // tailwind class like w-16
	h?: string // tailwind class like h-20
}) => {
	// Right stack tilts to the right: negative angle
	// The bottom card gets the largest negative angle, top card is near 0°
	const rotateGapRight = -rotateGap
	const startXRight = -startX
	const gapXRight = gapX
	const gapYRight = gapY

	const cardVariantsRight = useMemo(() => {
		return {
			hidden: () => ({
				x: 0,
				y: 0,
				rotate: 0,
			}),
			visible: (i: number) => ({
				x: -i * gapXRight + startXRight,
				y: -i * gapYRight,
				rotate: i * rotateGapRight,
				transition: {
					delay: i * 0.2,
					duration: 0.5,
				},
			}),
		}
	}, [cards.length])

	// Left stack tilts to the left: positive angle
	// Bottom card gets largest positive angle, top card near 0°
	const rotateGapLeft = rotateGap
	const startXLeft = startX
	const gapXLeft = -gapX
	const gapYLeft = gapY

	const cardVariantsLeft = useMemo(() => {
		return {
			hidden: () => ({
				x: 0,
				y: 0,
				rotate: 0,
			}),
			visible: (i: number) => ({
				x: -i * gapXLeft + startXLeft,
				y: -i * gapYLeft,
				rotate: i * rotateGapLeft,
				transition: {
					delay: i * 0.2,
					duration: 0.5,
				},
			}),
		}
	}, [cards.length])

	return (
		<>
			{Array.from({ length: cards.length }).map((_, i) => (
				<motion.div
					key={cards.length - 1 - i}
					custom={cards.length - 1 - i}
					variants={side === 'right' ? cardVariantsLeft : cardVariantsRight}
					initial="hidden"
					animate="visible"
					className={`absolute ${w} ${h} select-none text-black rounded-lg font-bold text-lg flex items-center justify-center ${side === 'right' ? 'shadow-[13px_-13px_22px_-9px_rgba(0,_0,_0,_0.15)] bg-appgreen' : 'shadow-[-13px_-13px_22px_-9px_rgba(0,_0,_0,_0.15)] bg-appred'}`}>
					{cards.length}
				</motion.div>
			))}
		</>
	)
}

export default AnkiResultCardStack
